<style lang="less">
@import "../../../../styles/public/public.less";
.info {
  height: 100%;
  width: 100%;
  position: relative;
  .info_model {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    margin-bottom: 5px;
    padding-right: 5px;
    .info_model_row {
      min-height: 40px;
      width: 100%;
      line-height: 40px;
      text-align: center;
      border-top: 1px solid rgba(169, 165, 165, 0.9);
      .infoleftborder {
        border-left: 1px solid rgba(169, 165, 165, 0.9);
        height: 100%;
        line-height: 40px;
      }
      .inforightborder {
        border-right: 1px solid rgba(169, 165, 165, 0.9);
      }
      .infobottomborder {
        border-bottom: 1px solid rgba(169, 165, 165, 0.9);
        height: 40px;
        line-height: 40px;
      }
      .info_model_row_t {
        height: 100%;
        width: 100px;
        background: rgba(7, 69, 113, 0.3);
      }
      .info_model_row_c {
        background: rgba(14, 79, 127, 0.8);
        height: 100%;
        width: 120px;
        padding: 0px 10px 0px 10px;
      }
    }
  }
}
.nosty {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
<template>
  <div class="info display_column">
    <div style="margin-top:-44px;margin-left:150px;">
      <Icon
        type="ios-arrow-up"
        color="#FFF"
        size="30"
        @click="click_openshow()"
        v-show="btn"
        title="收拢"
      />
      <Icon
        type="ios-arrow-down"
        color="#FFF"
        size="30"
        @click="click_closeup()"
        v-show="!btn"
        title="展示"
      />
      <!-- <Button type="info" >收拢</Button>
      <Button type="info">展示</Button>-->
    </div>
    <div class="info_model display_wrap_as" style="margin-top: 15px;">
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">
          <div style="height:100%;width:100%" class="display_row_jc_ac">
            <div>项目名称</div>
          </div>
        </Col>
        <Col span="9" class="infoleftborder">
          <div style="height:100%;width:100%;line-height:24px;" class="display_row_jc_ac">
            <div>{{dataList.prjname}}</div>
          </div>
        </Col>
        <Col span="5" class="infoleftborder">
          <div style="height:100%;width:100%" class="display_row_jc_ac">
            <div>申报书</div>
          </div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder">
          <div style="height:100%;width:100%" class="display_row_jc_ac">
            <div v-show="isshow">
              <a @click="info_download" style="text-decoration:underline;">项目申报书电子版</a>
            </div>
            <div v-show="!isshow">
              <span>项目申报书电子版</span>
            </div>
          </div>
        </Col>
      </Row>
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">
          <div style="height:100%;width:100%" class="display_row_jc_ac">
            <div>所属单位</div>
          </div>
        </Col>
        <Col span="9" class="infoleftborder">
          <div style="height:100%;width:100%;line-height:24px;" class="display_row_jc_ac">
            <div>{{dataList.DWMC}}</div>
          </div>
        </Col>
        <Col span="5" class="infoleftborder">
          <div style="height:100%;width:100%" class="display_row_jc_ac">
            <div>项目类别</div>
          </div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder">
          <div style="height:100%;width:100%" class="display_row_jc_ac">
            <div>{{dataList.prjtype}}</div>
          </div>
        </Col>
      </Row>
      <!-- <Row class="info_model_row">
        <Col span="5" class="infoleftborder display_row_js_ac">
          <div> 所属单位</div>       
        </Col>
        <Col span="9" class="infoleftborder">{{dataList.DWMC}}</Col>
        <Col span="5" class="infoleftborder">项目类别</Col>
        <Col span="5" class="infoleftborder inforightborder">{{dataList.prjtype}}</Col>
      </Row>-->
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">合作单位</Col>
        <Col span="9" class="infoleftborder">{{dataList.hzdw}}</Col>
        <Col span="5" class="infoleftborder">联系电话</Col>
        <Col span="5" class="infoleftborder inforightborder"></Col>
      </Row>
      <Row class="info_model_row" style="height:120px;">
        <Col span="5" class="infoleftborder" style="height:120px;line-height:120px">项目负责人</Col>
        <Col span="4" class="infoleftborder" style="height:120px;">
          <div class="infobottomborder">姓名</div>
          <div class="infobottomborder">学历</div>
          <div class="infobottomborder" style="border:none">联系电话</div>
        </Col>
        <Col span="5" class="infoleftborder" style="height:120px;">
          <div class="infobottomborder">{{dataList.fzrname}}</div>
          <div class="infobottomborder">{{dataList.fzreducation}}</div>
          <div class="infobottomborder" style="border:none">{{dataList.fzrphone}}</div>
        </Col>
        <Col span="5" class="infoleftborder" style="height:120px;">
          <div class="infobottomborder">出生年月</div>
          <div class="infobottomborder">职称</div>
          <div class="infobottomborder" style="border:none">邮箱</div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder" style="height:120px;">
          <div class="infobottomborder">{{dataList.fzrbirth}}</div>
          <div class="infobottomborder">{{dataList.fzrjobtitle}}</div>
          <div class="infobottomborder" style="border:none">{{dataList.fzremail}}</div>
        </Col>
      </Row>
      <Row class="info_model_row" style="height:80px;">
        <Col
          span="5"
          class="infoleftborder"
          style="height:80px;line-height:80px;"
        >项目组{{dataList.teamnunm}}人</Col>
        <Col span="4" class="infoleftborder">
          <div class="infobottomborder">高级</div>
          <div>{{dataList.high_level}}人</div>
        </Col>
        <Col span="5" class="infoleftborder">
          <div class="infobottomborder">中级</div>
          <div>{{dataList.middle_level}}人</div>
        </Col>
        <Col span="5" class="infoleftborder">
          <div class="infobottomborder">初级</div>
          <div>{{dataList.junior}}人</div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder">
          <div class="infobottomborder">其他</div>
          <div>{{dataList.othernum}}人</div>
        </Col>
      </Row>
      <Row class="info_model_row" style="height:150px;">
        <Col
          span="5"
          class="infoleftborder"
          style="height:150px;line-height:20px;padding-top:60px;"
        >
          主要研究内容
          <br />和关键技术
        </Col>
        <Col
          span="19"
          class="infoleftborder inforightborder display_row_jc_ac"
          style="height:150px;line-height:24px;padding: 3px;overflow-y: auto;display: flex;"
        >
          <div>{{dataList.note}}</div>
        </Col>
      </Row>
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">开始时间</Col>
        <Col span="9" class="infoleftborder">{{dataList.startdate}}</Col>
        <Col span="5" class="infoleftborder">结束时间</Col>
        <Col span="5" class="infoleftborder inforightborder">{{dataList.enddate}}</Col>
      </Row>
      <Row class="info_model_row" style="border-bottom:1px solid #a9a5a5f0">
        <Col span="5" class="infoleftborder">总经费</Col>
        <Col span="9" class="infoleftborder">{{dataList.allfunds}}</Col>
        <Col span="5" class="infoleftborder">申请园林局拨款</Col>
        <Col span="5" class="infoleftborder inforightborder">{{dataList.yljfunds}}</Col>
      </Row>
    </div>
  </div>
</template>

<script>
import bus from "../../../../app/event";
export default {
  components: {},
  data() {
    return {
      isshow: true,
      alldata: "",
      btn: false,
      dataList: {
        USERCODE:"",
        prjname: "",
        fzrjobtitle: "",
        othernum: "",
        prjtype: "",
        fzrphone: "",
        startdate: "",
        DWMC: "",
        fzremail: "",
        enddate: "",
        hzdw: "",
        teamnunm: "",
        fzrname: "",
        high_level: "",
        note: "",
        fzrbirth: "",
        middle_level: "",
        allfunds: "",
        fzreducation: "",
        junior: "",
        yljfunds: "",
        step: ""
      }
    };
  },
  methods: {
    //展示
    click_openshow() {
      this.btn = !this.btn;
      bus.$emit("detail_to_theme", false);
    },
    //收拢
    click_closeup() {
      this.btn = !this.btn;
      bus.$emit("detail_to_theme", true);
    },
    click_state(data, item) {
      if (data == "详细") {
        this.btn = false;
        if (this.$store.state.user.AOTHOR_ID != 0) {
          //申报单位
          if (item.DWID == this.$store.state.user.SSDW) {
            //是本单位的
            if (this.$store.state.user.ISADMIN == 0) {
              //判断是否是管理员(0：否  1：是)
              let aa = sessionStorage.getItem("USERCODE");
              if (item.USERCODE == aa) {
                //判断信息是否是登录人员
                this.dataList.yljfunds = item.YLJFUNDS;
                this.dataList.allfunds = item.ALLFUNDS;
              } else {
                this.dataList.yljfunds = "***";
                this.dataList.allfunds = "***";
              }
            } else {
              this.dataList.yljfunds = item.YLJFUNDS;
              this.dataList.allfunds = item.ALLFUNDS;
            }
          } else {
            this.dataList.yljfunds = "***";
            this.dataList.allfunds = "***";
          }
        } else {
          this.dataList.yljfunds = item.YLJFUNDS;
          this.dataList.allfunds = item.ALLFUNDS;
        }
        this.dataList.USERCODE = item.USERCODE;
        this.dataList.prjname = item.PRJNAME;
        this.dataList.fzrjobtitle = item.FZRJOBTITLE;
        this.dataList.othernum = item.OTHERNUM;
        this.dataList.prjtype = item.TYPENAME;
        this.dataList.fzrphone = item.FZRPHONE;
        this.dataList.startdate = item.STARTDATE;
        this.dataList.fzremail = item.FZREMAIL;
        this.dataList.enddate = item.ENDDATE;
        this.dataList.hzdw = item.HZDW;
        this.dataList.teamnunm = item.TEAMNUNM;
        this.dataList.fzrname = item.FZRNAME;
        this.dataList.high_level = item.HIGH_LEVEL;
        this.dataList.note = item.NOTE;
        this.dataList.fzrbirth = item.FZRBIRTH;
        this.dataList.middle_level = item.MIDDLE_LEVEL;
        this.dataList.fzreducation = item.FZREDUCATION;
        this.dataList.junior = item.JUNIOR;
        this.dataList.DWMC = item.DWMC;
        this.dataList.step = item.STEPNAME;
        let start = item.STARTDATE.split("/");
        let end = item.ENDDATE.split("/");
        this.dataList.timelimit = `${start[0]}年${start[1]}月${start[2]}日至 ${
          end[0]
        }年${end[1]}月${end[2]}日`;
        this.alldata = item;
        if (item.STEP >= 4 && item.STEP != 7) {
          this.isshow = false;
        } else {
          this.isshow = true;
        }
      }
    },
    //申报书下载
    info_download() {
      var _this = this;
      if (this.$store.state.user.ISADMIN == 0) {
        if (this.$store.state.user.USERCODE != this.dataList.USERCODE) {
          this.$Message.warning({
            content: "非本人申报项目，无操作权限！",
            duration: 3
          });
          return;
        }
      }

      this.$http
        .post(
          appurl.ip +
            "/ylkjservice/services/hander.ashx?action=getprofiledetail",
          {
            PRJNAME: this.alldata.PRJNAME,
            ID: this.alldata.ID,
            StageName: "temp"
          }
        )
        .then(response => {
          if (response.status == 200) {
            let data = response.data;
            if (data.length == 0) {
              this.$Message.warning({
                content: "暂无项目申报书信息！",
                duration: 3
              });
              return;
            } else {
              let name = data[0].filename;
              let downurl =
                appurl.downfile +
                "/projectmanager/" +
                _this.alldata.PRJNAME +
                "_" +
                _this.alldata.ID +
                "/temp/" +
                name;
              window.open(downurl);
            }
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "请求失败",
            duration: 3
          });
        });
    }
  },
  mounted() {
    bus.$on("center_to", this.click_state);
  },
  beforeDestroy() {
    bus.$off("center_to");
  },
  directives: {}
};
</script>


// WEBPACK FOOTER //
// detailed_information.vue?297123cd